var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1511 5.41096C12.1511 7.3175 10.5451 8.86306 8.56392 8.86306C6.58279 8.86306 4.97676 7.3175 4.97676 5.41096C4.97676 3.50442 6.58279 1.95886 8.56392 1.95886C10.5451 1.95886 12.1511 3.50442 12.1511 5.41096ZM10.9554 5.41096C10.9554 6.68199 9.88468 7.71236 8.56392 7.71236C7.24317 7.71236 6.17248 6.68199 6.17248 5.41096C6.17248 4.13993 7.24317 3.10956 8.56392 3.10956C9.88468 3.10956 10.9554 4.13993 10.9554 5.41096Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39401 10.3437C6.13109 9.79926 7.15839 9.43841 8.56395 9.43841C9.96952 9.43841 10.9968 9.79927 11.7339 10.3437C12.4655 10.8842 12.8634 11.5701 13.0793 12.1475C13.2692 12.6558 13.1361 13.1532 12.8176 13.5058C12.5099 13.8463 12.0441 14.0412 11.5532 14.0412H5.57464C5.08371 14.0412 4.61792 13.8463 4.31027 13.5058C3.99171 13.1532 3.85862 12.6557 4.0486 12.1475C4.26445 11.5701 4.66244 10.8841 5.39401 10.3437ZM6.12208 11.2565C5.6186 11.6285 5.33455 12.1068 5.17374 12.537C5.14018 12.6268 5.15864 12.6911 5.2126 12.7508C5.27747 12.8226 5.40518 12.8905 5.57464 12.8905H11.5532C11.7227 12.8905 11.8504 12.8226 11.9153 12.7508C11.9692 12.6911 11.9877 12.6268 11.9541 12.537C11.7933 12.1068 11.5093 11.6285 11.0058 11.2565C10.5078 10.8887 9.74708 10.5891 8.56395 10.5891C7.38083 10.5891 6.62006 10.8887 6.12208 11.2565Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d823b403b7c58e2e08cbc9d3974fa66b.svg";
export { ForwardRef as ReactComponent };